'use client'

import { useEffect } from 'react'

export default function RootRedirectPage() {
  useEffect(() => {
    window.location.replace('/it/')
  }, [])

  return null
}
